import template from './sw-category-upselling-form.html.twig'
import './sw-category-upselling-form.scss'

const { Criteria } = Shopware.Data
const { Component, Context } = Shopware
const { mapPropertyErrors, mapGetters, mapState } =
    Component.getComponentHelper()

Component.register('sw-category-upselling-form', {
    template,

    inject: ['repositoryFactory'],

    props: {
        upselling: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            showDeleteModal: false,
            showModalPreview: false,
            productStream: null,
            productStreamFilter: [],
            sortBy: 'name',
            sortDirection: 'ASC',
            useManualAssignment: false
        }
    },

    computed: {
        ...mapPropertyErrors('category.upselling', [
            'name',
            'type',
            'displayType',
            'sortingType'
        ]),

        ...mapState(() => Shopware.Store.get('swProductDetail'), [
            'product',
        ]),

        ...mapState(() => Shopware.Store.get('swCategoryDetail'), [
            'category',
        ]),

        productStreamRepository() {
            return this.repositoryFactory.create('product_stream')
        },

        productUpsellingRepository() {
            return this.repositoryFactory.create('zeo_product_upselling')
        },

        displayTitle() {
            if (this.upselling._isNew) {
                return this.$tc('sw-category.upselling.cardTitleUpselling')
            }
            return (
                this.upselling.translated.name ||
                this.$tc('sw-category.upselling.cardTitleUpselling')
            )
        },

        sortingTypes() {
            return [
                {
                    label: this.$tc(
                        'sw-category.upselling.priceDescendingSortingType'
                    ),
                    value: 'price:DESC'
                },
                {
                    label: this.$tc(
                        'sw-category.upselling.priceAscendingSortingType'
                    ),
                    value: 'price:ASC'
                },
                {
                    label: this.$tc('sw-category.upselling.nameSortingType'),
                    value: 'name:ASC'
                },
                {
                    label: this.$tc(
                        'sw-product.upselling.releaseDateDescendingSortingType'
                    ),
                    value: 'releaseDate:DESC'
                },
                {
                    label: this.$tc(
                        'sw-category.upselling.releaseDateAscendingSortingType'
                    ),
                    value: 'releaseDate:ASC'
                }
            ]
        },

        upsellingTypes() {
            return [
                {
                    label: this.$tc('sw-category.upselling.productStreamType'),
                    value: 'productStream'
                },
                {
                    label: this.$tc('sw-category.upselling.productListType'),
                    value: 'productList'
                }
            ]
        },

        previewDisabled() {
            return !this.productStream
        },

        sortingConCat() {
            return `${this.upselling.sortBy}:${this.upselling.sortDirection}`
        }
    },

    watch: {
        'upselling.productStreamId'() {
            if (!this.useManualAssignment) {
                this.loadStreamPreview()
            }
        }
    },

    created() {
        this.createdComponent()
    },

    methods: {
        createdComponent() {
            this.useManualAssignment = this.upselling.type === 'productList'
            if (
                !this.useManualAssignment &&
                this.upselling.productStreamId !== null
            ) {
                this.loadStreamPreview()
            }
        },
        onShowDeleteModal() {
            this.showDeleteModal = true
        },
        onCloseDeleteModal() {
            this.showDeleteModal = false
        },
        onConfirmDelete() {
            this.onCloseDeleteModal()
            this.$nextTick(() => {
                this.productUpsellingRepository.delete(
                    this.upselling.id,
                    Shopware.Context.api
                )
            })
        },
        openModalPreview() {
            if (this.previewDisabled) {
                return
            }
            this.loadStreamPreview()
            this.showModalPreview = true
        },

        closeModalPreview() {
            this.showModalPreview = false
        },

        loadStreamPreview() {
            this.productStreamRepository
                .get(this.upselling.productStreamId, Shopware.Context.api)
                .then((searchResult) => {
                    this.productStream = searchResult
                    if (!this.productStream) {
                        return
                    }
                    const filterRepository = this.repositoryFactory.create(
                        this.productStream.filters.entity,
                        this.productStream.filters.source
                    )
                    const criteria = new Criteria()
                    criteria.addFilter(
                        Criteria.equals(
                            'productStreamId',
                            this.upselling.productStreamId
                        )
                    )
                    return filterRepository
                        .search(criteria, Context.api)
                        .then((productFilter) => {
                            this.productStreamFilter = productFilter
                        })
                })
        },
        onSortingChanged(value) {
            ;[this.upselling.sortBy, this.upselling.sortDirection] =
                value.split(':')
        },
        onTypeChanged(value) {
            this.useManualAssignment = value === 'productList'
        }
    }
})
